import { kBiVizStyleOptionNames } from '@euler/model/bi/viz';
import { memo } from 'react';
import { StyleGroup } from '../StyleGroup';
import { StyleTextInput } from '../StyleTextInput';
import { biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

const kMaxSubtitle = 60;

/** A line under the title, e.g. what the numbers count. */
export const SubtitleOptions = memo(
  ({ style, onChange }: BiStyleOptionProps) => (
    <StyleGroup title={kBiVizStyleOptionNames.subtitle}>
      <StyleTextInput
        label="副标题"
        value={style?.subtitle ?? ''}
        placeholder="例如：不含退款"
        maxLength={kMaxSubtitle}
        onChange={text =>
          onChange(
            biWithStyleOption(
              style,
              'subtitle',
              text.trim() ? text : undefined,
            ),
          )
        }
      />
    </StyleGroup>
  ),
);
